module.exports = "<div class=\"outer\">\n  <div>\n    <a routerLink=\"about\">About Us</a>\n  </div>\n  <div>\n    <a routerLink=\"products/scarf\">Scarves</a>\n  </div>\n  <div>\n    <a routerLink=\"products/accessories\">Accesories</a>\n  </div>\n  <div>\n    <a routerLink=\"contact\">Contact Us</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/footer-links/footer-links.component.html
// module id = 413
// module chunks = 1